import { RefundLoadingState } from '../types';
import { ActionLoadingTypes, SET_REFUND_LOADING } from './actions';

const initialState: RefundLoadingState = new Set();

function loadingReducer(
	state: RefundLoadingState = initialState,
	{ type, payload }: ActionLoadingTypes
): RefundLoadingState {
	switch (type) {
		case SET_REFUND_LOADING: {
			const { operation, status } = payload;

			if (status && state.has(operation)) {
				return state;
			}

			if (!status && !state.has(operation)) {
				return state;
			}

			const newState = new Set(state);

			if (status) {
				newState.add(operation);
			} else {
				newState.delete(operation);
			}

			return newState;
		}

		default:
			return state;
	}
}

export default loadingReducer;
